var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScalable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(635 510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(-635 -510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    d: "M-551.106-508.621a14.11 14.11 0 0 1 10.432 4.292 14.112 14.112 0 0 1 4.294 10.435v67.788a14.691 14.691 0 0 1-3.991 10.47c-2.665 2.864-6.177 4.257-10.736 4.257h-67.784a14.049 14.049 0 0 1-10.436-4.3 14.047 14.047 0 0 1-4.294-10.432v-67.788a14.076 14.076 0 0 1 4.3-10.434 14.074 14.074 0 0 1 10.433-4.293h67.784m0-1.379h-67.784a15.536 15.536 0 0 0-11.409 4.7 15.53 15.53 0 0 0-4.7 11.409v67.788a15.5 15.5 0 0 0 4.7 11.409 15.5 15.5 0 0 0 11.409 4.7h67.784q7.378 0 11.746-4.7A16.162 16.162 0 0 0-535-426.106v-67.788a15.573 15.573 0 0 0-4.7-11.409 15.573 15.573 0 0 0-11.409-4.7z",
    fill: "#ff7557",
    "data-name": "Path 902",
    transform: "translate(635 510)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(-615.861 -494.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(0 16.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    d: "M-570.867-398.914l-8.63-4.983v-9.965l8.63-4.982 8.63 4.982v9.965zm-7.25-5.779l7.25 4.186 7.251-4.186v-8.372l-7.251-4.186-7.25 4.186z",
    fill: "#ff7557",
    "data-name": "Path 903",
    transform: "translate(579.497 418.844)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(24.457 49.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    d: "M-499.942-301.557l-8.63-4.983v-9.96l8.63-4.982 8.63 4.982v9.965zm-7.25-5.779l7.25 4.186 7.25-4.186v-8.372l-7.25-4.186-7.25 4.186z",
    fill: "#ff7557",
    "data-name": "Path 904",
    transform: "translate(508.572 321.487)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(25.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    d: "M-498.172-449.26l-7.383-4.262v-8.525l7.383-4.263 7.383 4.263v8.525zm-6-5.059l6 3.466 6-3.466v-6.932l-6-3.466-6 3.466z",
    fill: "#ff7557",
    "data-name": "Path 905",
    transform: "translate(505.555 466.31)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(14.313 34.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    d: "M-531.507-350.266l-6.482-3.742v-7.485l6.482-3.742 6.482 3.742v7.485zm-5.1-4.539l5.1 2.946 5.1-2.946v-5.895l-5.1-2.946-5.1 2.946z",
    fill: "#ff7557",
    "data-name": "Path 906",
    transform: "translate(537.989 365.235)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(33.292 11.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    d: "M-468.734-399.539l-14.215-8.207v-16.414l14.215-8.207 14.215 8.207v16.414zm-12.836-9l12.836 7.41 12.836-7.41v-14.821l-12.836-7.411-12.836 7.411z",
    fill: "#ff7557",
    "data-name": "Path 907",
    transform: "translate(482.949 432.367)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(36.934 17.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    d: "M-471.7-402.06a.69.69 0 0 1-.69-.69v-8.7l8.025-4.633a.689.689 0 0 1 .942.252.69.69 0 0 1-.252.942l-7.336 4.235v7.9a.689.689 0 0 1-.689.694z",
    fill: "#ff7557",
    "data-name": "Path 908",
    transform: "translate(472.389 416.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(28.284 3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    d: "M-496.783-448.142a.69.69 0 0 1-.69-.69v-3.783l3.476-2.007a.689.689 0 0 1 .942.252.69.69 0 0 1-.252.942l-2.787 1.609v2.987a.69.69 0 0 1-.689.69z",
    fill: "#ff7557",
    "data-name": "Path 909",
    transform: "translate(497.473 454.714)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(3.196 20.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    d: "M-569.54-398.281a.69.69 0 0 1-.69-.69v-5.309l4.888-2.822a.69.69 0 0 1 .942.252.69.69 0 0 1-.252.942l-4.2 2.424v4.512a.689.689 0 0 1-.688.691z",
    fill: "#ff7557",
    "data-name": "Path 910",
    transform: "translate(570.23 407.193)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(27.57 53.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    d: "M-498.853-301.355a.69.69 0 0 1-.69-.69v-5.309l4.888-2.822a.689.689 0 0 1 .942.252.69.69 0 0 1-.252.942l-4.2 2.424v4.512a.689.689 0 0 1-.688.691z",
    fill: "#ff7557",
    "data-name": "Path 911",
    transform: "translate(499.543 310.269)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(16.881 38.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    d: "M-529.851-348.6a.69.69 0 0 1-.69-.69v-3.275l3.006-1.735a.689.689 0 0 1 .942.252.69.69 0 0 1-.252.942l-2.316 1.337v2.478a.69.69 0 0 1-.69.691z",
    fill: "#ff7557",
    "data-name": "Path 912",
    transform: "translate(530.541 354.394)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(40.753 38.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    d: "M-460.625-333.475l-.69-1.194 15.878-9.168v-12.069h1.379v12.865z",
    fill: "#ff7557",
    "data-name": "Path 913",
    transform: "translate(461.314 355.906)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(7.803 35.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    d: "M-539.87-338.108l-17-9.814v-15.435h1.379v14.638l16.309 9.416z",
    fill: "#ff7557",
    "data-name": "Path 914",
    transform: "translate(556.869 363.357)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(12.705 11.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_449",
    d: "M0 0h15.041v1.379H0z",
    fill: "#ff7557",
    "data-name": "Rectangle 449",
    transform: "rotate(-30 14.034 3.761)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(39.354 11.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_450",
    d: "M0 0h1.379v4.837H0z",
    fill: "#ff7557",
    "data-name": "Rectangle 450",
    transform: "rotate(-60 1.034 .597)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalable);
export default __webpack_public_path__ + "static/media/Scalable.f3db98b0847a0b82b773e6cc2b4d730a.svg";
export { ForwardRef as ReactComponent };